import { useIntl } from 'react-intl';

export const DEFAULT_TRIAL_DAYS = {
  de: 30,
  'fr-FR': 30,
  'en-US': 30,
  'en-GB': 30,
  default: 30,
};

const useDefaultTrialDays = () => {
  const { locale } = useIntl();

  const defaultTrialDays =
    DEFAULT_TRIAL_DAYS[locale] || DEFAULT_TRIAL_DAYS.default;

  return { defaultTrialDays };
};

export default useDefaultTrialDays;
